import React from 'react';

const TextAreaField = ({ 
  label, 
  value, 
  onChange, 
  placeholder,
  name,
  rows = 4,
  required = false,
  disabled = false,
  className = ""
}) => {
  return (
    <label className="flex flex-col">
      {label && (
        <p className="text-[#111418] dark:text-gray-100 text-base font-medium leading-normal pb-2">
          {label} {required && <span className="text-red-500">*</span>}
        </p>
      )}
      <textarea
        name={name}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        rows={rows}
        required={required}
        disabled={disabled}
        className={`form-textarea flex w-full min-w-0 flex-1 resize-y overflow-hidden rounded-lg text-[#111418] dark:text-gray-100 focus:outline-0 focus:ring-2 focus:ring-primary/50 border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 placeholder:text-gray-400 p-[15px] text-base font-normal leading-normal ${className}`}
      />
    </label>
  );
};

export default TextAreaField;
